export default {
  stringEmpty: str => {
    return str === '' || str === null || str === undefined
  },
  notEmpty(str) {
    return !this.stringEmpty(str)
  },
  arrayEmpty: arr => {
    return arr.length === 0 || arr.indexOf('') !== -1
  },
  isEmail: str => {
    return RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,}').test(str)
  },
  isPhone: str => {
    return /^[0-9]{3} [0-9]{3}-[0-9]{4}$/.test(str)
  },
  isNumberBetween: (num, minNum = 0, maxNum = Number.MAX_VALUE) => {
    return !isNaN(num) && num % 1 === 0 && num >= minNum && num <= maxNum
  },
  isWebsiteUrl: str => {
    return RegExp(
      '^(http://www.|https://www.|http://|https://)?[a-z0-9]+([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$'
    ).test(str)
  },
  isValidPassword: str => {
    return new RegExp('^(?=.*[A-Z])(?=.*[0-9])(?=.{8,})').test(str)
  },
  isValidGatheringPrivatePassword: str => {
    return str.trim().length >= 4
  },
  isSamePassword: (password, passwordConfirmation) => {
    return password === passwordConfirmation
  },
  isBoolean: val => {
    return val === true || val === false
  }
}
